import { useMutation } from "@tanstack/react-query";

import { ApiError, apiFetch, setSessionRefreshEnabled } from "@/lib/api";
import type { LogoutOutput } from "@/types";

export function useLogout() {
  return useMutation({
    mutationFn: async () => {
      setSessionRefreshEnabled(false);
      try {
        return await apiFetch<LogoutOutput>("/v1/auth/logout", {
          method: "POST",
        });
      } catch (error) {
        if (!(error instanceof ApiError && error.status === 401)) {
          setSessionRefreshEnabled(true);
        }
        throw error;
      }
    },
  });
}
